/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { getResource } from "../../../language/resources/getResource";
import { Column, Row } from "../../../layout/flexbox";
import LabeledData from "../../../forms/elements/LabeledData";
import { LiftAccessRuleSet } from "./models";

type LiftAccessRuleSetHeaderProps = {
  resources: Record<string, any>;
  ruleSet: LiftAccessRuleSet;
};

const baseHeaderCss = css`
  margin-top: 15px;
  margin-left: 30px;
  margin-right: 30px;
`;

const gridRowCss = css`
  display: grid;
  grid-template-columns: 1fr 1.75fr;
  column-gap: 32px;
`;

const leftLabelCss = css`
  min-width: 90px;
`;

const rightLabelCss = css`
  min-width: 180px;
`;

export function LiftAccessRuleSetHeader({
  resources,
  ruleSet,
}: LiftAccessRuleSetHeaderProps) {
  return (
    <Column>
      <Row
        rootCss={css`
          ${baseHeaderCss};
          ${gridRowCss}
        `}
      >
        <LabeledData
          label={getResource(resources, "ACCESS_RULE_EDIT_SEASON")}
          labelCss={css`
            ${leftLabelCss}
          `}
          title={getResource(resources, "ACCESS_RULE_EDIT_SELLING_SEASON")}
          data={ruleSet.sellingSeasonDescription}
        />
        <LabeledData
          label={getResource(resources, "ACCESS_RULE_EDIT_FULFILLMENT_SEASON")}
          labelCss={css`
            ${rightLabelCss}
          `}
          title={getResource(resources, "ACCESS_RULE_EDIT_FULFILLMENT_SEASON")}
          data={ruleSet.fulfillmentSeasonDescription}
        />
      </Row>
      <Row
        rootCss={css`
          ${baseHeaderCss};
          ${gridRowCss}
        `}
      >
        <LabeledData
          label={getResource(resources, "ACCESS_RULE_EDIT_ID")}
          labelCss={css`
            ${leftLabelCss}
          `}
          title={getResource(resources, "ACCESS_RULE_EDIT_ENTITLEMENT_TYPE_ID")}
          data={ruleSet.entitlementTypeId}
        />
        <LabeledData
          label={getResource(resources, "ACCESS_RULE_EDIT_DESCRIPTION")}
          labelCss={css`
            ${rightLabelCss}
          `}
          title={getResource(resources, "ACCESS_RULE_EDIT_DESCRIPTION")}
          data={ruleSet.entitlementDescription}
        />
      </Row>
      <Row
        rootCss={css`
          ${baseHeaderCss};
          ${gridRowCss};
          margin-bottom: 15px;
        `}
      >
        <LabeledData
          label={getResource(resources, "ACCESS_RULE_EDIT_LOCATION")}
          labelCss={css`
            ${leftLabelCss}
          `}
          title={getResource(resources, "ACCESS_RULE_EDIT_LOCATION")}
          data={ruleSet.locationName}
        />
      </Row>
    </Column>
  );
}
